import { render, staticRenderFns } from "./_badge.vue?vue&type=template&id=71c42444&"
import script from "./_badge.vue?vue&type=script&lang=ts&"
export * from "./_badge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c42444')) {
      api.createRecord('71c42444', component.options)
    } else {
      api.reload('71c42444', component.options)
    }
    module.hot.accept("./_badge.vue?vue&type=template&id=71c42444&", function () {
      api.rerender('71c42444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_showcase/atoms/_badge.vue"
export default component.exports